var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 12.0007H5.33301V26.6673H10.6663V12.0007Z",
    fill: "#0086D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 5.33398H5.33301V10.6673H10.6663V5.33398Z",
    fill: "#0086D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 9.33398H13.333V14.6673H18.6663V9.33398Z",
    fill: "#0086D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 13.334H21.333V18.6673H26.6663V13.334Z",
    fill: "#0086D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 20.0007H21.333V26.6673H26.6663V20.0007Z",
    fill: "#0086D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 16.0007H13.333V26.6673H18.6663V16.0007Z",
    fill: "#0086D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarChart);
export default __webpack_public_path__ + "static/media/stacked_bar_chart.361853133efdf876f830758a6dd7b8cf.svg";
export { ForwardRef as ReactComponent };